export default "__VITE_ASSET__C8p1Lfj5__"